<template>
    <footer class="footer fixed-footer nav-footer">
        <div class="container">
            <router-link :to="{ name: prevRoute, params:params}" v-if="prevRoute" class="btn btn-light"><i class="fa text-sm" :class="prevIcon"></i> {{ prevLabel }}</router-link>
            <router-link :to="{ name: nextRoute, params:params}" v-if="nextRoute" class="btn btn-primary continue-btn icon-right ml-auto">{{ nextLabel }} <i class="fa text-sm" :class="nextIcon"></i></router-link>
        </div>
    </footer>
</template>

<script>
    export default {
        props: {
            additionalParams: {
                type: Object,
                default:null
            },
            nextIcon: {
                type: String,
                default: "fa-chevron-right"
            },
            nextLabel: {
                type: String,
                default: "Next"
            },
            nextRoute: {
                type: String,
                default: ""
            },
            prevIcon: {
                type: String,
                default: "fa-chevron-left"
            },
            prevLabel: {
                type: String,
                default: "Back"
            },
            prevRoute: {
                type: String,
                default: ""
            }
        },
    }
</script>

<style scoped>

</style>